import React from 'react';
import { twMerge } from 'tailwind-merge';
import { Col, Row } from 'components/Core/Grid';
import HyperLink from 'components/Core/HyperLink';
import Link from '../Link';

import { BusinessMenuContainer } from './styles';

const BusinessMenu = ({ dropdownItems }) => {
  const groups = Array.from(
    new Set(dropdownItems.map((i) => i?.group?.group).filter((group) => group != null)),
  );
  const groupedItems = groups.map((group) =>
    dropdownItems.filter((x) => x?.group?.group === group),
  );

  const viewAllCtas = {
    'Key Features': '/features',
    Trades: '/industries',
    Resources: '/toolbox',
  };

  return (
    <BusinessMenuContainer>
      <Row className="simple-nav-row" columnSpacing={4}>
        {groupedItems?.map((group, parentIndex) => (
          <>
            <Col
              xs={parseInt(24 / groupedItems.length)}
              className={twMerge(
                'simple-nav-col flex flex-col justify-between',
                parentIndex === groupedItems.length - 1 && 'bg-[#E8F4FE33]',
              )}
              key={parentIndex}
            >
              <div>
                <div className="group-title-container">
                  <h6 className="group-title" data-testid="group-title" key={parentIndex}>
                    {groups[parentIndex]}
                  </h6>
                  {viewAllCtas[groups[parentIndex]] && (
                    <HyperLink
                      data-position="Header - Menu Item CTA"
                      href={viewAllCtas[groups[parentIndex]]}
                      className="group-view-all"
                    >
                      View All
                    </HyperLink>
                  )}
                </div>
                {group.map((item, index) => (
                  <Link
                    item={item}
                    key={`link-${parentIndex}-${index}`}
                    data-testid="business-nav-link"
                  />
                ))}
              </div>
              {parentIndex === 0 && (
                <div className="type-footer pt-[7.5px]">
                  <HyperLink
                    href="/features/pro"
                    className="header-menu-cta text-xs !m-0 max-h-[34px] h-full !normal-case"
                    data-position="Header - Menu Item CTA"
                  >
                    Upgrade to Pro Products
                  </HyperLink>
                </div>
              )}
            </Col>
            {parentIndex < groupedItems.length - 2 && (
              <div className="mt-5 mb-[30px] border-l-0 border-t-0 border-b-0 border-r border-solid border-gray-100" />
            )}
          </>
        ))}
      </Row>
    </BusinessMenuContainer>
  );
};

export default BusinessMenu;
